import { useState, useEffect } from "react";
import { useLocation, Navigate, useNavigate, Outlet } from "react-router-dom";

import { Layout, Drawer, Affix, Spin } from "antd";
import Sidenav from "./Sidenav";
import Header from "./Header";
import Footer from "./Footer";
import { useSelector } from "react-redux";

const { Header: AntHeader, Content, Sider } = Layout;

function Main({ children }) {
  const [visible, setVisible] = useState(false);
  const [placement, setPlacement] = useState("right");
  const [sidenavColor, setSidenavColor] = useState("#1890ff");
  const [sidenavType, setSidenavType] = useState("transparent");
  const [fixed, setFixed] = useState(false);
  const [loading, setLoading] = useState(true);

  const openDrawer = () => setVisible(!visible);
  const handleSidenavType = (type) => setSidenavType(type);
  const handleSidenavColor = (color) => setSidenavColor(color);
  const handleFixedNavbar = (type) => setFixed(type);

  let { pathname } = useLocation();
  pathname = pathname.replace("/", "");

  useEffect(() => {
    if (pathname === "rtl") {
      setPlacement("left");
    } else {
      setPlacement("right");
    }
  }, [pathname]);

  const { user: authUser } = useSelector((x) => x.auth);
  const { isLoading } = useSelector((x) => x.system);

  const location = useLocation();

  if (!authUser) {
    // not logged in so redirect to login page with the return url
    // return <Link to="/sign-in" state={{ from: navigate("/sign-in") }} />;

    return <Navigate to="/" state={{ from: location }} replace />;
  } else {
    return (
      <Spin
        tip="Đang xử lý..."
        spinning={isLoading}
        size="large"
        style={{ top: "20%" }}
      >
        <Layout
          className={`layout-dashboard ${
            pathname === "profile" ? "layout-profile" : ""
          } ${pathname === "rtl" ? "layout-dashboard-rtl" : ""}`}
        >
          <Drawer
            title={false}
            placement={placement === "right" ? "left" : "right"}
            closable={false}
            onClose={() => setVisible(false)}
            visible={visible}
            key={placement === "right" ? "left" : "right"}
            width={250}
            className={`drawer-sidebar ${
              pathname === "rtl" ? "drawer-sidebar-rtl" : ""
            } `}
          >
            <Layout
              className={`layout-dashboard ${
                pathname === "rtl" ? "layout-dashboard-rtl" : ""
              }`}
            >
              <Sider
                trigger={null}
                width={250}
                theme="light"
                className={`sider-primary ant-layout-sider-primary ${
                  sidenavType === "#fff" ? "active-route" : ""
                }`}
                style={{ background: sidenavType }}
              >
                <Sidenav color={sidenavColor} />
              </Sider>
            </Layout>
          </Drawer>
          <Sider
            breakpoint="lg"
            collapsedWidth="0"
            onCollapse={(collapsed, type) => {
              console.log(collapsed, type);
            }}
            trigger={null}
            width={250}
            theme="light"
            className={`sider-primary ant-layout-sider-primary ${
              sidenavType === "#fff" ? "active-route" : ""
            }`}
            style={{ background: sidenavType }}
          >
            <Sidenav color={sidenavColor} />
          </Sider>
          <Layout>
            {fixed ? (
              <Affix>
                <AntHeader className={`${fixed ? "ant-header-fixed" : ""}`}>
                  <Header
                    onPress={openDrawer}
                    name={pathname}
                    subName={pathname}
                    handleSidenavColor={handleSidenavColor}
                    handleSidenavType={handleSidenavType}
                    handleFixedNavbar={handleFixedNavbar}
                  />
                </AntHeader>
              </Affix>
            ) : (
              <AntHeader className={`${fixed ? "ant-header-fixed" : ""}`}>
                <Header
                  onPress={openDrawer}
                  name={pathname}
                  subName={pathname}
                  handleSidenavColor={handleSidenavColor}
                  handleSidenavType={handleSidenavType}
                  handleFixedNavbar={handleFixedNavbar}
                />
              </AntHeader>
            )}
            <Content className="content-ant">
              <Outlet>{children}</Outlet>
            </Content>
            <Footer />
          </Layout>
        </Layout>
      </Spin>
    );
  }
}

export default Main;
